module.exports = __webpack_public_path__ + "img/p_selectedA@2x.f944fe85.png";